<template lang="pug">
	.comment-section
		.comment-count
			p {{ commentSection.commentCount }} comments
		.comment-thread-container
			p.spacey(v-if='!commentSection.commentCount') No Comments Yet!
			comment-thread(
				:parent='"root"'
				:section-ref='sectionRef'
				:active-comment-path='commentPath'
				@reply='setReplyTo'
			)
		add-comment(
			:reply-comment='replyingToComment'
			@comment='sendComment'
			@clear='clearComment'
		)
</template>

<script>
import { _firestore } from '@/lib/db';

import WriteComment from '@/lib/db/writeComment';
import { GetCommentPath } from '@/lib/db/getReplies';

import CommentThread from './CommentThread';
import AddComment from './AddComment';

export default {
	name : 'comment-section',

	props : {
		user : {
			required : true,
			type     : Object,
		},
		sectionId : {
			required : true,
			type     : String
		},
	},

	data : () => ( {
		sectionRef      : null,
		sectionListener : null,
		commentSection  : {},

		replyingToComment : null, // The comment that is being replied to

		commentPath : [],
	} ),

	created() {
		const { commentId } = this.$route.query;
		const { sectionId } = this;

		GetCommentPath( sectionId, commentId )
			.then( ( path ) => {
				this.commentPath = path;
			} )
			.catch( ( err ) => {
				console.warn( err );
			} );


	},

	watch : {
		sectionId : {
			immediate : true,

			handler( id ) {

				if ( !id ) {
					return;
				}

				// Detach listener
				if ( this.sectionListener ) {
					this.sectionListener();
				}

				this.sectionRef = _firestore.collection( 'commentSections' ).doc( id );

				this.sectionListener = this.sectionRef.onSnapshot( ( doc ) => {
					const commentSection = doc.data();

					if ( !commentSection ) {

						this.commentSection = {
							commentCount : 0,
						};

						// initialize comment section
						this.sectionRef.set( {
							commentCount : 0,
						} );

						return;
					}

					this.commentSection  = commentSection;
				} );
			}
		},
	},

	methods : {

		setReplyTo( comment ) {
			this.replyingToComment = comment;
		},

		sendComment( text ) {

			const { replyingToComment } = this;

			const replyingTo = replyingToComment ? replyingToComment.id : 'root';

			const comment = {
				user            : this.user.name,
				createdAt       : new Date(),
				createdBy       : this.user.uid,
				createdBySqlKey : this.user.usersKey,
				commentCount    : 0,
				text,
				replyingTo
			};

			WriteComment( this.sectionRef, comment, this.sectionId, replyingToComment )
				.then( ( id ) => {

					if ( replyingToComment ) {

						const link = ( () => {
							const { href } = window.location;
							const key = this.sectionId.split( '-' )[1];

							return `${href}?key=${key}&commentId=${id}`;
						} )();

						this.$emit( 'replied-to-comment', replyingToComment.createdBySqlKey, link );
					}

					this.replyingToComment = null;

				} );

		},

		clearComment() {
			this.replyingToComment = null;
		},

	},

	components : {
		CommentThread,
		AddComment
	}

};
</script>

<style lang="scss">
.comment-section {
	display: flex;
	flex-direction: column;

	.comment-count {
		border-top: dashed 1px $text-primary;
		border-bottom : dashed 1px $text-primary;
		padding: 15px;
	}

	.comment-thread-container {
		height: fit-content;
	}

	> .comment-thread-container {

		> p.spacey {
			text-align: center;
			margin-top: 30px;
		}

		> .comment-thread {

			> .thread {

				> .comment {

					> .replies {

						> .comment-thread {
							padding: 15px 0 0 0px;
						}
					}
				}
			}
		}
	}
}
</style>
